export const CASE_TIMELINE_TEST_ID: string = "case-timeline";

export const CASE_TIMELINE_LOADING_TEST_ID: string = "case-timeline-loading";

export const CASE_TIMELINE_BACK_TEST_ID: string = "case-timeline-back";

export const CASE_APPROVALS_TEST_ID: string = "case-approvals";

export const CASE_APPROVAL_ROW_TEST_ID: string = "case-approval-row";

export const CASE_CONCILIATION_TEST_ID: string = "case-conciliation-block";

export const CASE_CONCILIATION_DERIVED_TEST_ID: string = "case-conciliation-derived";

export const CASE_OPERATION_GROUP_TEST_ID: string = "case-operation-group";

export const CASE_EVENT_TEST_ID: string = "case-event";

export const CASE_GROUP_DATE_TEST_ID: string = "case-group-date";

export const CASE_RELATED_TEST_ID: string = "case-related-items";

export const CASE_RELATED_ROW_TEST_ID: string = "case-related-row";

export const CASE_RELATED_RESUBMISSION_TEST_ID: string = "case-related-resubmission-badge";

export const GROUP_BADGE_TEST_ID: string = "conciliation-group-badge";

export const DERIVED_BADGE_TEST_ID: string = "conciliation-derived-badge";

export const RESUBMISSION_BADGE_TEST_ID: string = "resubmission-badge";

export const NSU_RESUBMISSION_BADGE_TEST_ID: string = "nsu-resubmission-badge";

export const NSU_HISTORY_ITEM_TEST_ID: string = "nsu-history-item";
